import React from 'react';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const IntelligenceSection = () => {
  return (
    <section id="intelligence" className="py-24 bg-white border-b border-meetoi-aqua/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          {/* Left Text */}
          <div className="w-full lg:w-1/3">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-meetoi-offwhite border border-meetoi-aqua/50 mb-6">
              <span className="font-manrope text-[10px] font-bold uppercase tracking-widest text-meetoi-blue">Built for Relationship Intelligence</span>
            </div>
            <h2 className="font-sora text-3xl md:text-4xl font-bold text-meetoi-navy leading-tight mb-6">
              Insights that help you grow with intention.
            </h2>
            <p className="font-manrope text-base text-meetoi-text/80 leading-relaxed mb-8">
              Meetoi turns your interactions into meaningful insights so you can focus on the relationships that matter most. Look beyond simple contact lists to understand connection strength, follow-up consistency, and network growth.
            </p>
            <Button size="lg" className="bg-meetoi-navy text-white rounded-xl px-8 w-full sm:w-auto">
              Explore the platform
            </Button>
          </div>

          {/* Right Dashboard Mock */}
          <div className="w-full lg:w-2/3">
            <div className="bg-white rounded-[2rem] shadow-2xl border border-meetoi-aqua/30 overflow-hidden flex relative">
              
              {/* Sidebar Mock */}
              <div className="w-48 bg-meetoi-offwhite/50 border-r border-meetoi-aqua/20 p-4 hidden md:flex flex-col">
                <div className="flex items-center gap-2 mb-8 px-2">
                  <div className="w-6 h-6 bg-meetoi-navy rounded flex items-center justify-center"><SafeIcon icon={FiIcons.FiLayers} className="text-white text-xs"/></div>
                  <span className="font-sora font-bold text-sm text-meetoi-navy">Meetoi</span>
                </div>
                <div className="space-y-1">
                  <div className="flex items-center gap-3 px-2 py-2 bg-white rounded-lg shadow-sm border border-meetoi-aqua/20 text-meetoi-navy"><SafeIcon icon={FiIcons.FiHome} className="text-xs"/><span className="text-xs font-bold font-manrope">Dashboard</span></div>
                  <div className="flex items-center gap-3 px-2 py-2 text-meetoi-text/60"><SafeIcon icon={FiIcons.FiUsers} className="text-xs"/><span className="text-xs font-semibold font-manrope">Connections</span></div>
                  <div className="flex items-center gap-3 px-2 py-2 text-meetoi-text/60"><SafeIcon icon={FiIcons.FiBell} className="text-xs"/><span className="text-xs font-semibold font-manrope">Follow Ups</span></div>
                  <div className="flex items-center gap-3 px-2 py-2 text-meetoi-text/60"><SafeIcon icon={FiIcons.FiFileText} className="text-xs"/><span className="text-xs font-semibold font-manrope">Notes</span></div>
                  <div className="flex items-center gap-3 px-2 py-2 text-meetoi-text/60"><SafeIcon icon={FiIcons.FiBarChart2} className="text-xs"/><span className="text-xs font-semibold font-manrope">Analytics</span></div>
                  <div className="flex items-center gap-3 px-2 py-2 text-meetoi-text/60"><SafeIcon icon={FiIcons.FiCalendar} className="text-xs"/><span className="text-xs font-semibold font-manrope">Events</span></div>
                </div>
              </div>

              {/* Main Content Mock */}
              <div className="flex-1 p-6 md:p-8 bg-white">
                <div className="flex justify-between items-center mb-8">
                  <div>
                    <h3 className="font-sora font-bold text-xl text-meetoi-navy">Good morning, Sophia 👋</h3>
                    <p className="font-manrope text-xs text-meetoi-text/60 mt-1">Here's what's happening with your network.</p>
                  </div>
                  <div className="flex gap-2">
                    <div className="w-8 h-8 rounded-full bg-meetoi-offwhite flex items-center justify-center"><SafeIcon icon={FiIcons.FiSearch} className="text-meetoi-text/50 text-xs"/></div>
                    <div className="w-8 h-8 rounded-full bg-meetoi-offwhite flex items-center justify-center"><SafeIcon icon={FiIcons.FiUser} className="text-meetoi-text/50 text-xs"/></div>
                  </div>
                </div>

                {/* Metrics Grid */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                  <div className="bg-white border border-meetoi-aqua/30 rounded-xl p-3 shadow-sm">
                    <div className="text-[9px] font-bold text-meetoi-text/50 uppercase tracking-wider mb-1">Total Connections</div>
                    <div className="flex items-baseline gap-2">
                      <span className="font-sora font-bold text-xl text-meetoi-navy">248</span>
                      <span className="text-[10px] font-bold text-emerald-500">+12%</span>
                    </div>
                  </div>
                  <div className="bg-white border border-meetoi-aqua/30 rounded-xl p-3 shadow-sm">
                    <div className="text-[9px] font-bold text-meetoi-text/50 uppercase tracking-wider mb-1">Follow Up This Week</div>
                    <div className="flex items-baseline gap-2">
                      <span className="font-sora font-bold text-xl text-meetoi-navy">12</span>
                      <span className="text-[10px] font-bold text-meetoi-coral">-2%</span>
                    </div>
                  </div>
                  <div className="bg-white border border-meetoi-aqua/30 rounded-xl p-3 shadow-sm">
                    <div className="text-[9px] font-bold text-meetoi-text/50 uppercase tracking-wider mb-1">New This Month</div>
                    <div className="flex items-baseline gap-2">
                      <span className="font-sora font-bold text-xl text-meetoi-navy">36</span>
                    </div>
                  </div>
                  <div className="bg-meetoi-blue/5 border border-meetoi-blue/20 rounded-xl p-3 shadow-sm">
                    <div className="text-[9px] font-bold text-meetoi-blue uppercase tracking-wider mb-1">Relationship Strength</div>
                    <div className="flex items-baseline gap-2">
                      <span className="font-sora font-bold text-xl text-meetoi-blue">82%</span>
                      <span className="text-[10px] font-bold text-emerald-500">+3%</span>
                    </div>
                  </div>
                </div>

                {/* Lists */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="md:col-span-2">
                    <h4 className="font-manrope font-bold text-sm text-meetoi-navy mb-3">Recent connections</h4>
                    <div className="space-y-3">
                      {[ 
                        { name: 'Alex Morgan', role: 'Product Manager at Loom', source: 'Met at Web Summit', time: '2h ago' },
                        { name: 'Jamie Lee', role: 'CEO at Brightly', source: 'Met at Lunch', time: '1d ago' },
                        { name: 'Taylor Smith', role: 'Head of Marketing at Carta', source: 'Met via LinkedIn', time: '2d ago' }
                      ].map((c, i) => (
                        <div key={i} className="flex items-center justify-between p-2 rounded-lg hover:bg-meetoi-offwhite transition-colors">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-meetoi-aqua/30 flex items-center justify-center text-[10px] font-bold text-meetoi-navy">{c.name.charAt(0)}</div>
                            <div>
                              <div className="font-manrope font-bold text-xs text-meetoi-navy">{c.name}</div>
                              <div className="font-manrope text-[10px] text-meetoi-text/60">{c.role}</div>
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="font-manrope text-[10px] text-meetoi-text/80">{c.source}</div>
                            <div className="font-manrope text-[9px] text-meetoi-text/40">{c.time}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <h4 className="font-manrope font-bold text-sm text-meetoi-navy mb-3">Follow up reminders</h4>
                    <div className="space-y-3">
                      {[ 
                        { name: 'Alex Morgan', time: 'Tomorrow, 10:00 AM' },
                        { name: 'Jamie Lee', time: 'Friday, 9:00 AM' },
                        { name: 'Casey Brown', time: 'Next Monday, 11:00 AM' }
                      ].map((r, i) => (
                        <div key={i} className="flex items-center gap-3 p-2 bg-white border border-meetoi-aqua/20 rounded-lg shadow-sm">
                          <div className="w-6 h-6 rounded-full bg-meetoi-coral/10 flex items-center justify-center text-meetoi-coral">
                            <SafeIcon icon={FiIcons.FiBell} className="text-[10px]" />
                          </div>
                          <div>
                            <div className="font-manrope font-bold text-[11px] text-meetoi-navy">{r.name}</div>
                            <div className="font-manrope text-[9px] text-meetoi-text/60">{r.time}</div>
                          </div>
                        </div>
                      ))}
                      <div className="text-center pt-2">
                        <span className="font-manrope text-[10px] font-bold text-meetoi-blue cursor-pointer">View all reminders</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};